module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qr-code-container"
  }, [_c('div', {
    staticClass: "qr-image-container"
  }, [_c('a', {
    attrs: {
      "title": "Click to download the QR code",
      "alt": "Click to download the QR code"
    },
    on: {
      "click": function($event) {
        _vm.downloadAsImage()
      }
    }
  }, [_c('img', {
    ref: "imageTag",
    staticClass: "qr-image",
    attrs: {
      "crossOrigin": "Anonymous"
    }
  })])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-circle btn-icon-only btn-default clickable",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.downloadAsImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73744e68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/QRCode.vue
// module id = 752
// module chunks = 0